import { Box } from "@mui/material";
import { shade } from "polished";
import styled, { css } from "styled-components";

import { colors, globalStyle } from "global/globalStyle";

export interface IBodyList {
  paddingleft?: string;
  paddingright?: string;
  paddingtop?: string;
  paddingbottom?: string;
  backgroudColor?: string;
}

export interface IContainer {
  disabled?: boolean;
}

export interface IHeader {
  backgroudColor?: string;
}

export const Container = styled.div<IContainer>`
  width: 100%;
  border: none;
  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.6;
      cursor: default;
    `}
`;

export const Header = styled.button<IHeader>`
  height: 30px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background: none;
  background: ${(props) => props.backgroudColor ?? "none"};
  border: none;

  h1 {
    font-family: ${globalStyle.fontFamily};
    font-weight: 600;
    font-size: 1rem;
    color: #000;
    text-transform: initial;
  }

  svg {
    color: #7887a9;
  }
  cursor: pointer;

  &:focus {
    outline: none;
  }
`;

export const Body = styled.div<IBodyList>`
  padding-left: ${(props) => props.paddingleft ?? "1px"};
  padding-right: ${(props) => props.paddingright ?? "4px"};
  padding-top: ${(props) => props.paddingtop ?? "14px"};
  padding-bottom: ${(props) => props.paddingbottom ?? "0px"};
  background: ${(props) => props.backgroudColor ?? "none"};
`;

export const ButtonNavigate = styled.button<{ selected: boolean }>`
  width: 100%;
  text-align: start;
  display: flex;
  flex-direction: column;
  background: none;
  border: none;
  padding: 10px 12px;
  font-weight: 400;
  font-size: 14px;
  font-family: ${globalStyle.fontFamily};
  cursor: pointer;
  text-transform: inherit;
  margin-bottom: 4px;

  &:hover {
    background: ${(props) =>
      props.selected
        ? shade(0.2, colors.default_blue)
        : colors.default_base_grey};
    border-radius: 4px;
  }

  ${(props) =>
    props.selected &&
    css`
      background: ${colors.default_blue};
      color: ${colors.default_base_white};
      font-weight: 600;
      border-radius: 4px;
    `}

  &:focus {
    outline: none;
  }
`;

export const Left = styled(Box as any)`
  width: "100%";
  height: "30px";
  display: "flex";
  flex-direction: row;
  align-items: "center";
  left: "0";
  justify-content: "flex-end";
`;

export const Right = styled(Box as any)`
  width: "100%";
  height: "60px";
  display: "flex";
  align-items: "center";
  gap: "24px";
  right: "1";
  justify-content: "flex-end";
  padding-right: "15px";
`;

export const EmptyMessage = styled(Box as any)`
  display: "flex";
  flex-direction: row;
  justify-content: "start";
  font-style: "italic";
  text-align: start;
`;
